const SubscriptionTier = {
	PRO: 'pro',
	SITE_MAKER: 'site_maker',
	TEAM: 'team',
	ENTERPRISE: 'enterprise',
} as const;

export default SubscriptionTier;
